import { authPost } from './authMiddleware';

export const postMinePersonnelList = (data) => {
    return authPost('/api/Personnel', data);
}